export default __webpack_public_path__ + "static/media/glass_roofs.5dbcfd9c.JPG";